import { connect } from 'react-redux'
import SliderTabs from '../components/SliderTabs'



const mapStateToProps = (state, ownProps) => {
    return {
        tabs: ownProps.tabs,
        selected: state.ui.index,
        onTabClick: ownProps.onTabClick,
        visible: ownProps.tabs[state.ui.index].showTab
    }
}



const SliderTabsContainer = connect(
    mapStateToProps
)(SliderTabs)

export default SliderTabsContainer

